import React from 'react'

import { ConfirmModal, useModalContext } from '@fourthwall/components'

import cartAbandonmentEmailPromoImage from '../../../../Recommendations/modules/CartAbandonmentEmailPromoRecommendation/assets/cart-abandonment-email-promo.png'
import * as S from './ConfirmEmailPromoCodeModal.styled'

type ConfirmEmailPromoCodeModalProps = {
  onConfirm: () => void
}

export const ConfirmEmailPromoCodeModal = ({ onConfirm }: ConfirmEmailPromoCodeModalProps) => {
  const { close } = useModalContext()

  return (
    <ConfirmModal
      text={
        <S.Container>
          <S.ImageWrapper>
            <S.Image src={cartAbandonmentEmailPromoImage} alt="Cart abandonment email promo" />
          </S.ImageWrapper>
          <S.Content>
            <S.Title>Boost sales with a discount in abandoned checkout emails</S.Title>
            <p>
              Increase your checkout recovery rate up to 40% when you offer a a discount code in
              abandoned checkout reminder emails
            </p>
          </S.Content>
        </S.Container>
      }
      confirmLabel="Offer free shipping on large orders"
      confirmButtonAnalytics="abandonmentDiscount"
      onConfirm={onConfirm}
      onCancel={close}
      close={close}
      title=""
    />
  )
}
